<template>
  <div>
    <div class="text-left">
      <p class="font-bold text-xl mb-4" v-if="!title">
        {{ $t("新增收货地址") }}
      </p>
      <p class="font-bold text-xl mb-4" v-else>
        {{ title }}{{ $t("收货地址") }}
      </p>
      <el-form status-icon :model="form" ref="ruleForm" :rules="rules" label-position="left" :inline="false" size="medium"
        label-width="auto">


        <el-form-item :label="$t('收件人')" prop="receiver">
          <el-input v-model="form.receiver" :placeholder="$t('长度在 1 到 20 个字符')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('联系电话')" required>
          <div class="flex flex-nowrap justify-between space-x-3">
            <el-form-item prop="code" class="w-1/3">
              <el-select class="flex-grow" v-model="form.code" :placeholder="$t('区号')">
                <el-option v-for="item in codes" :key="item.id" :label="`${item.value}(${item.key})`"
                  :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="phone" class="w-2/3">
              <el-input v-model.number="form.phone" :placeholder="$t('联系电话')"></el-input>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item prop="area_id" :label="$t('国家或地区')" required>
          <el-select class="flex-grow w-full" v-model="form.area_id" :placeholder="$t('国家或地区')">
            <el-option v-for="item in areas" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('收货地址')" prop="areanames">
          <el-input v-model="form.areanames" :placeholder="$t('选择所在地区')" @click.native="getArea"></el-input>
        </el-form-item>
        <!-- <el-form-item label="所在地区" prop="areanames">
          <el-input v-model="form.areanames" placeholder="请选择所在地区" @click.native="getArea"></el-input>
        </el-form-item> -->

        <el-form-item :label="$t('详细地址')" prop="address">
          <el-input v-model="form.address" :placeholder="$t('详细地址')"></el-input>
        </el-form-item>

        <el-form-item label="" prop="isdefault">
          <el-checkbox v-model="form.isdefault">
            {{ $t("设为默认收货地址") }}
          </el-checkbox>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">{{
            $t("保存")
          }}</el-button>
        </el-form-item>
      </el-form>

      <!-- <el-dialog :visible.sync="area_dialog" destroy-on-close width="51rem" title append-to-body> -->
      <!-- <ir-map
        @getAreasResult="getAreasResult"
        mainAddress="云南省 昆明市"
        :mainPoint="mainPoint"
        areaNames="云南省 昆明市 呈贡区"
        :mapHeight="500"
      ></ir-map> -->
      <!-- </el-dialog> -->
    </div>
    <el-dialog :visible.sync="area_dialog" destroy-on-close width="51rem" title append-to-body>
      <IRMap ref="mapView" @mounted="mapMounted" style="width:600px;height:300px;margin:0 auto" @location-selected="handleLocationSelected"></IRMap>
      <div class="query-div">
        <el-button @click="sureButton">确定</el-button>
        <el-button @click="cancelButton">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, toRefs, ref, onMounted } from "@vue/composition-api";
import { defineComponent } from "@vue/runtime-dom";
import { lensProp, omit, pipe, prop, set } from "ramda";
import { getAreas } from "/src/API/flight/getAreas.js";
import IRMap from '@/components/base/IRMap';
// import IrMap from "@/components/base/ir-map.vue";

export default defineComponent({
  props: {
    addr_message: [Object, String],
    title: String,
  },
  components: { IRMap },
  setup(props, ctx) {
    const codes = ref();
    onMounted(async () => {
      const res = await ctx.root.$lazy("datadic");
      codes.value = res.countryareacode;
    });
    const form = ref();
    if (props.addr_message) {
      console.log(props.addr_message);
      form.value = {
        receiver: props.addr_message.receiver,
        phone: '',
        code: '',
        // phone: Number(props.addr_message.phone.slice(4)),
        // code: props.addr_message.phone.slice(0, 3),
        aid: props.addr_message.id,
        area_id: props.addr_message.area?.id,
        address: props.addr_message.address,
        isdefault: props.addr_message.isdefault,
        id: props.addr_message.id,
        areanames: props.addr_message.areanames
      };
      let arr = props.addr_message.phone.split('-')
			form.value.code = arr[0]
			form.value.phone= arr[1]
    } else {
      form.value = {
        receiver: "",
        phone: "",
        code: "",
        aid: "",
        area_id: "",
        address: "",
        isdefault: false,
        areanames: "",
        latitude: "",
        longitude: "",
      };
    }
    const rules = reactive({
      receiver: [
        {
          required: true,
          message: ctx.root.$t("请输入收件人名称"),
          trigger: "blur",
        },
        {
          min: 1,
          max: 20,
          message: ctx.root.$t("长度在 1 到 20 个字符"),
          trigger: "blur",
        },
      ],
      code: [
        { required: true, message: ctx.root.$t("请选择区号"), trigger: "blur" },
      ],
      phone: [
        {
          // type: "number",
          required: true,
          message: ctx.root.$t("请输入电话号码"),
          trigger: "change",
        },
      ],
      area_id: [
        {
          required: true,
          message: ctx.root.$t("请选择国家或地区"),
          trigger: "blur",
        },
      ],
      city: [
        {
          required: false,
          message: ctx.root.$t("请选择城市"),
          trigger: "change",
        },
      ],
      address: [
        {
          required: true,
          message: ctx.root.$t("请输入详细地址"),
          trigger: "change",
        },
      ],
      number: [
        {
          required: false,
          message: ctx.root.$t("请输入邮编"),
          trigger: "change",
        },
      ],
      ps: [
        {
          required: true,
          max: 200,
          message: ctx.root.$t("字数不超过200个字符"),
          trigger: "change",
        },
      ],
      areanames: [
        {
          required: true,
          message: "请选择所在地区",
          trigger: "change",
        }
      ]
    });

    const submitForm = (formName) => {
      // ctx.emit("closeAddress");
      console.log("long:", longitude);
      console.log("lat:", latitude);
      ctx.refs[formName].validate(async (valid) => {
        if (valid) {
          ctx.root.$doing();
          const query = (o) => {
            const val = () => prop("code", o) +'-'+ prop("phone", o);
            const setVal = set(lensProp("phone"), val());
            return pipe(setVal, omit(["code"]))(o);
          };
          const res = await ctx.root.$callapi(
            "user/saveAddress",
            query(form.value)
          );
          ctx.root.$done();
          if (res.code === 0) {
            if (props.title == "新增" || !props.title) {
              ctx.emit("reload");
              ctx.refs.ruleForm.resetFields();
            } else {
              ctx.emit("remodify");
              ctx.refs.ruleForm.resetFields();
            }
            ctx.emit("closeAddress");
          }
        } else {
          return false;
        }
      });
    };

    const areas = getAreas(ctx);

    //地图
    const area_dialog = ref(false);
    const getArea = () => {
      area_dialog.value = true;
      // getLatByAddress();
    };

    let longitude = 0;
    let latitude = 0;
    const mapMounted = () => {
      //地图组件挂载成功
      // let map = this.$refs.mapView.map;
      let map = ctx.refs.mapView.map;
      // console.log("地图书初始化完成", this.$refs.mapView.map)
      console.log("地图书初始化完成", ctx.refs.mapView.map)
      map.addEventListener("click", ({ lat, lng }) => {
        console.log("click", lng, lat)
        longitude = lng;
        latitude = lat;
        // console.log("long:",longitude);
        // console.log("lat:",latitude);
        map.clearMarkers()
        map.addMarker(lng, lat)
      })
    };
    const handleLocationSelected = ({lng,lat})=>{
      longitude = lng
      latitude = lat
    }

    // 点击收货地址弹框中的确定按钮
    const sureButton = () => {
      // form.value.longitude = longitude;
      // form.value.latitude = latitude;
      area_dialog.value = false;
      getAreasResult(longitude, latitude)
    };

    const cancelButton = () => {
      area_dialog.value = false;
    }
    // const mainPoint = ref({
    //   lat: "",
    //   lng: "",
    // });
    // const getLatByAddress = async () => {
    //   // const res = await ctx.root.$callapi("main/getLatByAddress");
    //   // mainPoint.value.lat = res.data.latitude;
    //   // mainPoint.value.lng = res.data.longitude;
    //   mainPoint.value.lat = 24.855004;
    //   mainPoint.value.lng = 102.839752;
    // };

    const getAreasResult = async (lo, ln) => {
      // form.value.areanames = val.areaNames;
      // form.value.address = val.address;
      form.value.latitude = ln;
      form.value.longitude = lo;
      area_dialog.value = false;
      const res = (
        await ctx.root.$callapi("getAddressByLatLng", {
          // coordtype: "wgs84",
          latitude: ln,
          longitude: lo,
        })
      ).data;
      // form.value.area_id = res.area.id;
      if (res) {
        form.value.areanames = res.areastext ? res.areastext : ctx.root.$t("未知地区")
      } else {
        ctx.$toast(ctx.root.$t('请求地名失败'), 'error')
      }
      // console.log("res", res);
      // console.log("long:",form.value.longitude);
      // console.log("lat:",form.value.latitude);
    };

    // return { form, rules, submitForm, ...toRefs(areas), codes, getAreasResult, area_dialog, mainPoint, getArea, mapMounted };
    return { form, rules, submitForm, ...toRefs(areas), codes, area_dialog, getArea, mapMounted, sureButton, cancelButton,handleLocationSelected  };
  },
});
</script>

<style scoped lang="scss">::v-deep .el-form-item--medium .el-form-item__label {
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.query-div {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}</style>
